import {
    goPush,
    goReplace,
    goBack,
    goLogin,
    goLogout,
    goRegister,
    goRealname
} from './base'

import {
    goCourse,
    goTeacher
} from './course'

export default {
    // base
    goPush,
    goReplace,
    goBack,


    goLogin,
    goLogout,
    goRegister,
    goRealname,

    goCourse,
    goTeacher
}
